import { find as _find, filter as _filter, map as _map } from 'lodash'
import { component } from 'picoapp'
import { addItemById } from '@/lib/cart.js'
import getProductJson from '@/lib/getProductJson.js'
import { FastAverageColor } from 'fast-average-color'
import Flickity from 'flickity'
require('flickity-as-nav-for')
require('flickity-sync')

import moment from 'moment'
require('moment-timezone')

class ProductDetails {
  constructor(node, ctx) {
    // bindings
    this.onClickCarouselThumb = this.onClickCarouselThumb.bind(this)
    this.updateVariant = this.updateVariant.bind(this)

    this.onOptionClick = this.onOptionClick.bind(this)
    this.onAddToCartClick = this.onAddToCartClick.bind(this)
    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)

    // selectors
    this._node = node

    this._carousel_main = this._node.querySelector('.carousel-main')
    this._carousel_nav = this._node.querySelector('.carousel-nav')
    this._thumbs = Array.from(this._node.querySelectorAll('.carousel-thumb'))

    this._quantity = this._node.querySelector('.quantity-item')
    this._options = this._node.querySelectorAll('.product-opt')
    this._product_opts = this._node.querySelector('.product-opts')
    this._add_to_cart_btn = this._node.querySelector('.add-to-cart-btn')
    this._error = this._node.querySelector('.add-to-cart-error')
    this._variant_image = this._node.querySelectorAll('[data-image-id]')

    this._discounted_price = this._node.querySelector('.discounted-price');
    this._regular_price = this._node.querySelector('.regular-price');

    if (this._discounted_price && this._regular_price) {
      let tz = moment.tz.guess(),
          now = moment(new Date(), 'YYYY-MM-DD HH:mm:ss').tz(tz),
          now_et = moment(new Date(), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York'),
          discount_start = moment(this._discounted_price.getAttribute('data-start'), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York').startOf('day'),
          discount_end = moment(this._discounted_price.getAttribute('data-end'), 'YYYY-MM-DD HH:mm:ss').tz('America/New_York').startOf('day');

      if (discount_start.isBefore(now) && now.isBefore(discount_end)) {
        this._discounted_price.style.display = "flex";
        this._regular_price.style.display = "none";
      } else {
        this._discounted_price.style.display = "none";
        this._regular_price.style.display = "flex";
      }
    }

    this._variants_data = this._product_opts ? JSON.parse(this._product_opts.getAttribute('data-variants')) : false
    this._unavailable_variants = this._variants_data ? _filter(this._variants_data, { 'available': false }) : false

    this._cart_btn_enabled = true
    this._current_variant = null
    this._current_id = this._node.querySelector('input[name="product_id"]')
    this._first_or_selected_id = this._current_id ? parseInt(this._current_id.value, 10) : false

    if (this._carousel_main) {
      this._flickity_carousel = new Flickity(this._carousel_main, {
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        percentPosition: true,
        setGallerySize: false,
        accessibility: false,
        sync: '.carousel-nav'
      })

      this._flickity_carousel.viewport.style.touchAction = "pan-y pinch-zoom"

      this._thumbs.forEach((thumb) => thumb.addEventListener('click', this.onClickCarouselThumb, false))
      this._flickity_nav = new Flickity(this._carousel_nav, {
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        setGallerySize: false,
        accessibility: false,
        cellAlign: 'left',
        contain: true,
        draggable: false
      })
    }

    this._color_opts = this._node.querySelectorAll('.color-opt')
    if (this._color_opts.length > 0) {
      this.setColorValues()
    }

    this._error_to = 0

    this._options.forEach((option) => option.addEventListener('click', this.onOptionClick, false))

    if (this._add_to_cart_btn) {
      this._add_to_cart_btn.addEventListener('click', this.onAddToCartClick, false)
    }

    if ('URLSearchParams' in window && this._variant_image.length > 0) {
      let url_search = new URLSearchParams(document.location.search),
          url_variant = url_search.get('variant')

      if (url_search && url_variant) {
        let url_variant_id = parseInt(url_variant, 10)

        if (url_variant_id !== this._first_or_selected_id && this._first_or_selected_id !== false) {
          getProductJson().then(json => {
            // Loop n find...
            json.variants.forEach((variant, i) => {
              if (variant.id === url_variant_id) {
                this._current_variant = variant
              }
            })

            // Auto-select options...
            this._options.forEach((option) => {
              option.classList.remove('--selected')
            })

            json.options.forEach((option, i) => {
              let option_key = `option${i + 1}`,
                  option_el = this._node.querySelector(`.product-opt[data-opt="${option_key}"][data-name="${this._current_variant[option_key]}"]`)
                  // option_name = option_el.getAttribute('data-name')
              option_el.classList.add('--selected')
            })

            // Update...
            this.updateVariant()
          })
        }
      }
    }

    this.checkAvailability()

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Click thumb.
  //
  onClickCarouselThumb(e) {
    let el = e.currentTarget

    if (el.classList.contains('.is-selected') === false) {
      this._flickity_carousel.select(this._thumbs.indexOf(el))
    }
  }

  //
  // Set color values
  //
  setColorValues() {
    this._color_opts.forEach((opt) => {
      let color_src = opt.getAttribute('data-src')

      if (color_src) {
        let fac = new FastAverageColor()

        fac.getColorAsync(color_src)
          .then((color) => {
            opt.querySelector('span').style.backgroundColor = color.hex
          })
          .catch(e => {
            console.log(e);
          });
      }
    })
  }

  //
  // Check availability
  //
  checkAvailability() {
    if (this._current_variant === null && this._first_or_selected_id !== false) {
      getProductJson().then(json => {
        this._current_variant = _find(json.variants, { 'id': this._first_or_selected_id })
        this.updateStuff()
      })
    } else {
      this.updateStuff()
    }
  }

  updateStuff() {
    if (this._add_to_cart_btn) {
      this._cart_btn_enabled = true
      this._add_to_cart_btn.offsetHeight;
      this._add_to_cart_btn.classList.remove('disabled')

      if (this._current_variant.fulfillment_service && this._current_variant.fulfillment_service === 'gift_card') {
        this._add_to_cart_btn.innerHTML = `<span>Add to Cart</span>`
      } else {
        this._add_to_cart_btn.innerHTML = `<span>Add to Cart</span>`
        // this._add_to_cart_btn.innerHTML = `<span>PREORDER</span>`
      }

      if (this._unavailable_variants) {
        getProductJson().then(current_product => {
          if (current_product.options.length > 1 || current_product.variants.length > 1) {
            let unavailable_opts = _map(this._unavailable_variants, 'options'),
                selected_opts = this._node.querySelectorAll('.--selected'),
                selected_str = ''

            selected_opts.forEach((el) => {
              selected_str += el.getAttribute('data-name')
            })

            if (unavailable_opts.indexOf(selected_str) !== -1) {
              this._cart_btn_enabled = false
              this._add_to_cart_btn.classList.add('disabled')
              this._add_to_cart_btn.innerHTML = '<span>Out of Stock</span>'
            }
          }
        })
      }
    }
  }

  //
  // Handle option click.
  //
  onOptionClick(e) {
    let el = e.currentTarget,
        id = el.getAttribute('data-id'),
        opt_group = el.getAttribute('data-opt')

    if (el.classList.contains('--selected') === false && el.classList.contains('disabled') === false) {
      // Add selected class to clicked option...
      this._options.forEach((option) => {
        if (option.getAttribute('data-opt') === opt_group) {
          option.classList.remove('--selected')
        }
      })
      el.classList.add('--selected')

      // Set new product id...
      getProductJson().then(json => {
        let data_variants = json.variants,
            data_options = json.options,
            total_match = data_options.length,
            selected_opts = [],
            new_index = 0

        data_options.forEach((item, i) => {
          let option_key = `option${i + 1}`,
              option_el = this._node.querySelector(`[data-opt="${option_key}"].--selected`),
              option_name = option_el.getAttribute('data-name')

          selected_opts.push(option_name)
        })

        data_variants.forEach((variant, vi) => {
          let match = 0

          data_options.forEach((item, i) => {
            let option_key = `option${i + 1}`
            if (selected_opts[i] == variant[option_key]) {
              match++
            }
          })

          if (match === total_match) {
            new_index = vi
          }
        })

        this._current_variant = data_variants[new_index]

        this.updateVariant()
        this.updateParams()
        this.checkAvailability();
      })

    }
  }

  //
  // Update variant...
  //
  updateVariant() {
    if (this._current_variant) {
      // Update current ID (for add to cart)
      this._current_id.value = this._current_variant.id

      // Update variant images
      this._variant_image.forEach((item, i) => {
        let image_id = parseInt(item.getAttribute('data-image-id'), 10)
        item.classList.remove('--current')

        if (image_id === this._current_variant.image_id) {
          item.classList.add('--current')
        }
      })

      if (this._carousel_main) {
        this._flickity_carousel.select(0)
      }
    }
  }

  updateParams() {
    if ('URLSearchParams' in window) {
      let url_search = new URLSearchParams(window.location.search)
      url_search.set('variant', this._current_variant.id)

      let new_path = window.location.pathname + '?' + url_search.toString()
      history.replaceState(history.state, '', new_path)
    }
  }

  //
  // Add to cart.
  //
  onAddToCartClick() {
    if (this._cart_btn_enabled === false) {
      return false
    }

    let num = 1

    if (this._quantity) {
      num = parseInt(this._quantity.innerText, 10)
    }

    Promise.all([
      addItemById(this._current_id.value, num)
    ]).then(([{item, cart}]) => {
      // console.log(item, cart)
    }).catch((error) => {
      this.showCartError(error)
    })
  }

  //
  // Show a cart error.
  //
  showCartError(error) {
    if (error === '') {
      this._error.style.display = 'none'
    } else {
      this._error.style.display = 'block'
    }

    this._error.innerText = error

    clearTimeout(this._error_to)
    this._error_to = setTimeout(() => this.showCartError(''), 4000)
  }

  //
  // Handle quantity update.
  //
  onQuantityUpdate() {
    this._error.innerText = ''
  }

  //
  // Unmount.
  //
  unmount() {
    // events
    if (this._carousel_main) {
      this._thumbs.forEach((thumb) => thumb.removeEventListener('click', this.onClickCarouselThumb, false))
    }

    this._options.forEach((option) => option.removeEventListener('click', this.onOptionClick, false))
    if (this._add_to_cart_btn) {
      this._add_to_cart_btn.removeEventListener('click', this.onAddToCartClick, false)
    }
  }
}

export default component((node, ctx) => new ProductDetails(node, ctx))
